/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_9_DInputs */

const en_tut_gl_9_d = /** @type {(inputs: Tut_Gl_9_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A map of rooms and desks where members are visibly present, move around, and talk informally.`)
};

const id_tut_gl_9_d = /** @type {(inputs: Tut_Gl_9_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta ruang dan meja tempat anggota terlihat hadir, berpindah, dan mengobrol ringan.`)
};

/**
* | output |
* | --- |
* | "A map of rooms and desks where members are visibly present, move around, and talk informally." |
*
* @param {Tut_Gl_9_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_9_d = /** @type {((inputs?: Tut_Gl_9_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_9_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_9_d(inputs)
	return en_tut_gl_9_d(inputs)
});